import React from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { ItemDelegate } from '@leverege/molten/imagine';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY = {};
export default class KeysUpsellDetailRenderer {
  getValueComponent(object, cxt) {
    return /*#__PURE__*/_jsx(KeysUpsell, {
      object: object,
      context: cxt
    });
  }
  getComponents(object, cxt = EMPTY) {
    const {
      clientProps
    } = cxt;
    const location = ItemDelegate.getItem(clientProps.parentItem?.data?.data?.location?.id);
    if (location?.data?.keysEnabled) {
      return null;
    }
    return [{
      style: {},
      component: this.getValueComponent(object, cxt)
    }];
  }
}
function KeysUpsell() {
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "keysUpsell",
    layout: "flex:screenTitleControls",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "keysUpsellTitle|boldLeft",
        children: "Upgrade to Unlock Keys Tracking"
      }), /*#__PURE__*/_jsxs(Text, {
        variant: "bodyLeft",
        children: ["RecovR Tags can be sold with each of the vehicle's keys. Interested in adding them to your product offering? \xA0", /*#__PURE__*/_jsx("a", {
          href: "https://recovr.biz/keys",
          target: "_blank",
          rel: "noreferrer",
          style: {
            fontWeight: 'bold'
          },
          children: "Contact Us!"
        })]
      })]
    }), /*#__PURE__*/_jsx("img", {
      alt: "Recovr Tag",
      height: 130,
      width: 130,
      src: "https://storage.googleapis.com/recovr-ui-assets/tag-no-data.png"
    })]
  });
}